<template>
  <el-dialog title="设备保养详情"
    :visible.sync="$parent.deviceInfoCom"
    width="40%">
    <div style="height:50vh">
      <el-table :data="tableData"
        height="100%"
        style="width: 100%;">
        <el-table-column prop="number"
          label="NO."
          width="80">
        </el-table-column>
        <el-table-column label="设备名称"
          prop="name"
          :width="flexWidth('name',tableData,'设备名称')" />
        <el-table-column label="设备地址"
          prop="location"
          :width="flexWidth('address',tableData,'设备地址')" />
        <el-table-column prop="maintenanceContent"
          label="保养内容"
          :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer"
      class="dialog-footer">
      <el-button @click="$parent.deviceInfoCom = false">取 消</el-button>
      <el-button type="primary"
        @click="$parent.deviceInfoCom = false">确 定</el-button>
    </span>
  </el-dialog>

</template>

<script>
import { flexWidth } from "@/assets/js/utils";
import api from "@/api";
export default {
  props: {
    clickItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tableData: [],
    };
  },
  methods: {
    flexWidth,
    async getInfo() {
      let res = await api.maintenancePlanGetECInfo({
        ids: this.clickItem.deviceIds.join(","),
      });
      if (res && res.data.code == 200) {
        this.tableData = res.data.data;
        this.tableData.map((v, i) => {
          v.number = i + 1;
        });
      }
    },
  },
  created() {
    this.getInfo();
  },
};
</script>

<style>
</style>